import React from 'react';
import { Helmet } from 'react-helmet';
import './style.css';
import { SignIn } from '../../components/Signin/Signin';

export const Login = () => {
  return (
    <div className="signin-container">
      <Helmet>
        <title>Login | VoteSee</title>
        <meta name="description" content="Login to your VoteSee account to access personalized features and track your political engagement." />
        <meta name="robots" content="noindex, nofollow" /> {/* Discourage indexing */}
        <link rel="canonical" href="https://www.votesee.com/login" />
        <meta property="og:title" content="Login | VoteSee" />
        <meta property="og:description" content="Login to your VoteSee account to access personalized features." />
        <meta property="og:url" content="https://www.votesee.com/login" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.votesee.com/images/previews/find-rep-preview.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Login | VoteSee" />
        <meta name="twitter:description" content="Login to your VoteSee account to access personalized features." />
        <meta name="twitter:image" content="https://www.votesee.com/images/previews/find-rep-preview.png" />
      </Helmet>
      <SignIn />
    </div>
  );
};
